import { Observable, Subject, catchError, of, takeUntil, take } from 'rxjs';
import { Component, ChangeDetectorRef, OnDestroy, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { PointOfSaleType, SlidesType, VisualsType } from '@sifca-monorepo/ecommerce-generator';
import { AuthService, PosService, SharedService, SlidesService, VisualsService } from '../../services';

@Component({
  template: '',
})
export class BaseFooterComponent implements OnInit, OnDestroy {
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  year: number;
  fb: boolean;
  current = '/';
  yelp: boolean;
  twitter: boolean;
  youtube: boolean;
  fbAdresse: string;
  instagram: boolean;
  pinterest: boolean;
  posId: string = '';
  yelpAdresse: string;
  pos: PointOfSaleType;
  instaAdresse: string;
  twitterAdresse: string;
  youtubeAdresse: string;
  authenticated: boolean;
  iconSlider: SlidesType;
  pinterestAdresse: string;
  visuals$: Observable<VisualsType>;

  constructor(
    protected posService: PosService,
    protected authService: AuthService,
    protected slidesService: SlidesService,
    protected visualsService: VisualsService,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
      this.visuals$ = this.visualsService.visuals$;
  }

  ngOnInit(): void {
    this.year = new Date().getFullYear();

    this.sharedService.posId$.pipe(takeUntil(this.unsubscribeAll)).subscribe((posId) => {
      this.posId = posId;

      this.slidesService
        .getSlides(this.posId)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe((res) => {
          if (res) {
            this.iconSlider = res.find((slide) => slide.reference === 'icon-slider');
          }
        });

      this.posService
        .getPos(this.posId)
        .pipe(
          take(1),
          catchError(() => of(null)),
        )
        .subscribe();
    });

    this.posService.pos$.pipe(takeUntil(this.unsubscribeAll)).subscribe((response) => {
      this.pos = response;
      this.changeDetectorRef.markForCheck();
    });

    this.authService.authenticated$.pipe(takeUntil(this.unsubscribeAll)).subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });
  }

  shareOnFacebook(shareUrl: string): void {
    if (isPlatformBrowser(this.platformId)) {
      const win = window as any;
      if (typeof win.FB !== 'undefined') {
        win.FB.init({
          appId: '278013208459559',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v22.0',
        });

        win.FB.ui(
          {
            display: 'popup',
            method: 'share_open_graph',
            action_type: 'og.likes',
            action_properties: JSON.stringify({
              object: shareUrl,
            }),
          },
          (response: any) => {
            if (response && !response.error_message) {
              console.log('Shared successfully');
            } else {
              console.error('Share error:', response);
            }
          },
        );
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
